<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import StoryblokClient from 'storyblok-js-client'

const token = 'd28dV9KFDIrQLL9rXhs98wtt';

let storyapi = new StoryblokClient({
  accessToken: token
})

export default {
  name: "App",
  computed: {
    ...mapState({
      alert: state => state.alert
    }),
    getToken() {
      return window.$cookies.get('SESSION');
    }
  },
  watch: {
    /* eslint-disable */
    $route(to, from) {
      // clear alert on location change
      this.clearAlert();
    }
    /* eslint-enable */
  },
  created () {
    if(this.getToken) {
      this.$store.dispatch('fetch');
    }
    // 4. Initialize the Storyblok Client Bridge to allow us to subscribe to events
    // from the editor itself.
    window.storyblok.init({
      accessToken: token
    })
    window.storyblok.on('change', () => {
      // this will indicate to load the home story, exchange that with the full slug of your content
     // either it is the page URL or hardcoded as in the example below

      // this.getAgent( this.Agent, 'draft')
      this.getStory( this.Post, 'draft')
      // this.getProperties( this.Post, 'draft')
      // this.getSupport( this.Support, 'draft')
      // this.getRegio( this.Regio, 'draft')
      this.getReview( this.Review, 'draft')
      this.getFunnel_toelichting( this.Funnel_toelichting, 'draft')
    })
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        // this.getAgent( this.Agent, 'draft'),
        this.getStory( this.Post, 'draft'),
        // this.getProperties( this.Post, 'draft')
        // this.getSupport( this.Support, 'draft')
        // this.getRegio( this.Regio, 'draft')
        this.getReview( this.Review, 'draft')
        this.getFunnel_toelichting( this.Funnel_toelichting, 'draft')
      } else {
        // this.getAgent( this.Agent, 'published')
        this.getStory( this.Post, 'published')
        // this.getProperties( this.Post, 'published')
        // this.getSupport( this.Support, 'published')
        // this.getRegio( this.Regio, 'published')
        this.getReview( this.Review, 'published')
        this.getFunnel_toelichting( this.Funnel_toelichting, 'published')
      }
    })
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear"
    }),
    // getAgent(slug, version) {
    //   storyapi.get('cdn/stories/', {
    //     starts_with: "Agent/",
    //     version: version
    //   })
    //   .then((response) => {
    //   this.$store.dispatch ("saveAgent", response.data);
    //   })
    // },
    getStory(slug, version) {
      storyapi.get('cdn/stories/', {
        starts_with: "Blog/",
        version: version
      })
      .then((response) => {
      this.$store.dispatch ("savePosts", response.data);
      })
    },
    // getProperties(slug, version) {
    //   storyapi.get('cdn/stories/', {
    //     starts_with: "properties/",
    //     version: version
    //   })
    //   .then((response) => {
    //   this.$store.dispatch ("saveProperties", response.data);
    //   })
    // },
    // getSupport(slug, version) {
    //   storyapi.get('cdn/stories/', {
    //     starts_with: "support/",
    //     version: version
    //   })
    //   .then((response) => {
    //   this.$store.dispatch ("saveSupport", response.data);
    //   })
    // },
    // getRegio(slug, version) {
    //   storyapi.get('cdn/stories/', {
    //     starts_with: "regio/",
    //     version: version
    //   })
    //   .then((response) => {
    //   this.$store.dispatch ("saveRegio", response.data);
    //   })
    // },
    getReview(slug, version) {
      storyapi.get('cdn/stories/', {
        starts_with: "review/",
        version: version
      })
      .then((response) => {
      this.$store.dispatch ("saveReview", response.data);
      })
    },
    getFunnel_toelichting(slug, version) {
      storyapi.get('cdn/stories/', {
        starts_with: "Funnel_toelichting/",
        version: version
      })
      .then((response) => {
      this.$store.dispatch ("saveFunnel_toelichting", response.data);
      })
    },
  } 
};
</script>

<style>
@import "isaluAssets/css/main.css";
</style>
